import { CommonLoaderService, CommonSubmitButtonService } from "../Services";

export const loaderType = {
  BUTTON: "button",
  COMMON: "common",
  INLINE: "inline",
  LIST: "list",
};

export const loaderClass = {
  BUTTON: "",
  COMMON: "loaderCommon",
  INLINE: "loaderInline",
  LIST: "loaderList",
};

export const StartLoader = (type, loaderText) => {
  switch (type) {
    case loaderType.BUTTON:
      CommonSubmitButtonService.startLoading();
      break;

    case loaderType.COMMON:
      CommonLoaderService.startLoading(type, loaderText);
      break;
    // case loaderType.INLINE:
    //   CommonInlineLoaderService.startLoading(loaderClass.INLINE);
    //   break;

    // case loaderType.LIST:
    //   CommonListLoaderService.startLoading(loaderClass.LIST);
    //   break;
    default:
  }
};

export const StopLoader = (type) => {
  switch (type) {
    case loaderType.BUTTON:
      CommonSubmitButtonService.stopLoading();
      break;

      case loaderType.COMMON:
        CommonLoaderService.stopLoading();
        break;
    // case loaderType.INLINE:
    //   CommonInlineLoaderService.stopLoading();
    //   break;

    // case loaderType.LIST:
    //   CommonListLoaderService.stopLoading();
    //   break;
    default:
  }
};
